/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Prereq_JobInputs */

const en_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a job posting first.`)
};

const de_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuege zuerst eine Stelle hinzu.`)
};

const fr_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez d'abord une offre d'emploi.`)
};

const es_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primero anade una oferta de empleo.`)
};

const it_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi prima un'offerta di lavoro.`)
};

const nl_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg eerst een vacature toe.`)
};

const pl_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw dodaj oferte pracy.`)
};

const fi_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää ensin työpaikkailmoitus.`)
};

const da_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilföj forst en jobopslag.`)
};

const sv_cover_letters_prereq_job = /** @type {(inputs: Cover_Letters_Prereq_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagg forst till en jobbanons.`)
};

/**
* | output |
* | --- |
* | "Add a job posting first." |
*
* @param {Cover_Letters_Prereq_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_prereq_job = /** @type {((inputs?: Cover_Letters_Prereq_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Prereq_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_prereq_job(inputs)
	if (locale === "fr") return fr_cover_letters_prereq_job(inputs)
	if (locale === "es") return es_cover_letters_prereq_job(inputs)
	if (locale === "it") return it_cover_letters_prereq_job(inputs)
	if (locale === "nl") return nl_cover_letters_prereq_job(inputs)
	if (locale === "pl") return pl_cover_letters_prereq_job(inputs)
	if (locale === "fi") return fi_cover_letters_prereq_job(inputs)
	if (locale === "da") return da_cover_letters_prereq_job(inputs)
	if (locale === "sv") return sv_cover_letters_prereq_job(inputs)
	return en_cover_letters_prereq_job(inputs)
});